import React from "react";
import { OptionContent } from "../../styles";
import { ButtonGroup } from "@caelor/ui";
import { useEasyHtmlStore } from "../../../../../../stores/use-easyhtml-store";

function ModeSwitcher() {
  const { mode, setMode } = useEasyHtmlStore((state) => ({
    mode: state.data.mode,
    setMode: state.setMode,
  }));

  const BOOLEAN_OPTIONS = [
    { label: "HTML", mode: "html", value: mode === "html" },
    { label: "CSS", mode: "css", value: mode === "css" },
    { label: "JS", mode: "javascript", value: mode === "javascript" },
  ];

  return (
    <OptionContent>
      <ButtonGroup
        items={BOOLEAN_OPTIONS}
        value={true}
        returnWholeItem={true}
        onClick={({ mode }) => setMode(mode)}
      />
    </OptionContent>
  );
}

export default ModeSwitcher;
